import React from 'react';

const IconArrowLeft = () => {
  return (
    <svg data-test="iconarrowleft" width="9" height="15" viewBox="0 0 9 15" fill="none">
      <path
        d="M8.25151 1.82573L6.99293 0.574219L0 7.57422L7 14.5742L8.25151 13.3227L2.50303 7.57422L8.25151 1.82573Z"
        fill="#0385D1"
      />
    </svg>
  );
};

export default IconArrowLeft;
